import { useFlipperFlag } from './useFlipperFlag'
import useResponsiveDesign from './useResponsiveDesign'
import { useIsPioneerStarterOrGrowth } from './useIsPioneerStarterOrGrowth'

export const useIsOnboardingRedesign = () => {
  const location = window.location // eslint-disable-line no-restricted-properties
  const { isMobile } = useResponsiveDesign()
  const isOnboardingRedesignFlag = useFlipperFlag('onboarding_redesign')
  const isPioneer = useIsPioneerStarterOrGrowth() === 'pioneer'

  const isOnRegistration = location.pathname.includes('/signup')
  const isOnLogin = location.pathname.includes('/login')
  const isRegistrationOrLoginPath = isOnRegistration || isOnLogin

  // Need to use the attribute because the flag is not always loaded in the signup and login flows
  const isOnboardingRedesignAttribute = document.documentElement.getAttribute('data-ff-onboarding-redesign') === 'on'

  // Forced redesign is used for testing purposes in beta, cause we can't use the flag in the signup and login flows without a user or workspace
  const isOnboardingRedesignForced = location.search.includes('redesign=true')

  return (
    (isOnboardingRedesignFlag || isOnboardingRedesignAttribute || isOnboardingRedesignForced) &&
    !isMobile &&
    (!isPioneer || isRegistrationOrLoginPath)
  )
}
